<template>
  <div>
    <Header></Header>
    <main id="content" role="main">
      <!-- Contact Form Section -->
      <div class="container space-top-3 space-top-lg-4 space-bottom-2">
        <div class="row">
          <div class="col-lg-6 mb-9 mb-lg-0">
            <div class="mb-5">
              <h1>创联天成</h1>
              <p>
                为客户提供融合创新，面向未来的信息化、智能化、可视化数据挖潜与运营支撑服务的专业技术公司。
              </p>
            </div>

            <!-- Leaflet -->
            <div
              id="map"
              class="min-h-300rem mb-5"
              data-hs-leaflet-options='{
                 "map": {
                   "scrollWheelZoom": false,
                   "coords": [37.78968,112.560935]
                 }
                }'
            ></div>

            <!-- End Leaflet -->

            <div class="row">
              <div class="col-sm-6">
                <div class="mb-3">
                  <span class="d-block h5 mb-1">联系电话:</span>
                  <span class="d-block text-body font-size-1">
                    (0351) 8788808</span
                  >
                </div>

                <div class="mb-3">
                  <span class="d-block h5 mb-1">电子邮件:</span>
                  <span class="d-block text-body font-size-1"
                    >web@cltc.info</span
                  >
                </div>
              </div>

              <div class="col-sm-6">
                <div class="mb-3">
                  <span class="d-block h5 mb-1">公司地址:</span>
                  <span class="d-block text-body font-size-1"
                    >太原市小店区北美N1文创区8号楼604室</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="ml-lg-5">
              <!-- Form -->
              <el-form class="card shadow-lg mb-4" :model="form" :rules="rulus" ref="form">
                <div
                  class="card-header border-0 bg-light text-center py-4 px-4 px-md-6"
                >
                  <h2 class="h4 mb-0">快速联系我们</h2>
                </div>

                <div class="card-body p-4 p-md-6">
                  <div class="row">
                    <div class="col-sm-6">
                      <!-- Form Group -->
                        
                        <el-form-item label="您的姓名" prop="name">
                          <el-input
                          type="text"
                          placeholder="姓名"
                          v-model="form.name"
                        />
                        </el-form-item>
                        
                      <!-- End Form Group -->
                    </div>

                    <div class="col-sm-6">
                      <!-- Form Group -->
                     <el-form-item label="您的公司（选填）">
                        <el-input
                          type="text"
                          placeholder="公司"
                          v-model="form.company"
                        />
                     </el-form-item>
                       
                     
                      <!-- End Form Group -->
                    </div>

                    <div class="col-sm-12">
                      <!-- Form Group -->
                     
                        <el-form-item label="您的电子邮件" prop="email">
                          <el-input
                          type="email"
                          placeholder="web@cltc.info"
                          v-model="form.email"
                        />
                        </el-form-item>
                        
                      
                      <!-- End Form Group -->
                    </div>
                    <div class="col-sm-12">
                      <!-- Form Group -->
                       
                          <el-form-item label="您的疑问产品(选填)">
                            <el-radio-group v-model="form.product">
                              <el-radio label="数据可视化">数据可视化</el-radio>
                              <el-radio label="系统集成">系统集成</el-radio>
                              <el-radio label="其他产品或业务">其他产品或业务</el-radio>
                            </el-radio-group>
                          </el-form-item>
                         
                      <!-- End Form Group -->
                    </div>

                    <div class="col-sm-12">
                      <!-- Form Group -->
                    
                          <el-form-item label="您的留言内容">
                            <el-input type="textarea" rows="4" v-model="form.message" placeholder="您可以在这里留言 请输入您希望的合作内容 ...">

                            </el-input>
                          </el-form-item>
                         
                      <!-- End Form Group -->
                    </div>
                  </div>
                  <button
                  @click="submit()"
                  type="button"
                  class="btn btn-block btn-primary transition-3d-hover"
                  >
                    提交
                  </button>
                </div>
              </el-form>
              <!-- End Form -->

              <div class="text-center">
                <p class="small">我们将在收到您的邮件后尽快与您回复</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Contact Form Section -->
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js";
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js";

import "@/assets/vendor/font-awesome/css/all.min.css";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css";
import "@/assets/vendor/fancybox/dist/jquery.fancybox.min.css";
import "@/assets/vendor/aos/dist/aos.css";
import "@/assets/css/theme.css";
import "@/assets/vendor/hs-header/dist/hs-header.min.js";
import "@/assets/vendor/hs-go-to/dist/hs-go-to.min.js";
import "@/assets/vendor/hs-unfold/dist/hs-unfold.min.js";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js";
import "@/assets/vendor/hs-show-animation/dist/hs-show-animation.min.js"; //
// import "@/assets/vendor/jquery-validation/dist/jquery.validate.min.js"; //
import "@/assets/vendor/leaflet/dist/leaflet.js"; //
import "@/assets/vendor/leaflet/dist/leaflet.css";
import "@/assets/js/hs.leaflet.js";
import "@/assets/vendor/fancybox/dist/jquery.fancybox.min.js";
import "@/assets/vendor/appear.js";
import "@/assets/vendor/circles/circles.min.js";
import AOS from "aos";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@/assets/js/hs.core.js";
import "@/assets/js/hs.fancybox.js";

import "@/assets/js/hs.circles.js";
import "@/assets/vendor/hs-counter/dist/hs-counter.min.js";
import Header from "../components/header";
import Footer from "../components/footer";
import {validEmail} from '../utils/validate'
import {addhelp} from '../request/index'
export default { 
  components: {
    Header,
    Footer,
  },
  data() {
    var checkEmail = (rule, value, callback) =>{
      if(!value){
        return callback(new Error('邮箱不能为空'));
      }else{
        if(!validEmail(value)){
            return callback(new Error('邮箱格式不对'));
        }else{
          callback()
        }
      }
    }
    return {
      form:{
        name:null,
        company:null,
        email:null,
        message:null,
        product:null
      },
       rulus:{
        name:[{required:true,message:'请填写您的姓名',trigger: 'blur'}],
        email:[{validator: checkEmail, trigger: 'blur',required:true}]
      }
    };
  },
  mounted() {
    $(document).ready(function () {
      // initialization of header
      // var header = new HSHeader($("#header")).init();

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($(".js-mega-menu"), {
        desktop: {
          position: "left",
        },
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold(".js-hs-unfold-invoker").init();

      // initialization of show animations
      $(".js-animation-link").each(function () {
        var showAnimation = new HSShowAnimation($(this)).init();
      });

      // initialization of form validation
      // $(".js-validate").each(function () {
      //   $.HSCore.components.HSValidation.init($(this), {
      //     rules: {
      //       confirmPassword: {
      //         equalTo: "#signupPassword",
      //       },
      //     },
      //   });
      // });

      // initialization of leaflet
      $("#map").each(function () {
        var leaflet = $.HSCore.components.HSLeaflet.init($(this)[0]);
        // 变灰
        L.tileLayer(
          "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoieGluZ3hpbmcxMjM0NTYiLCJhIjoiY2tsdWpkZ2oyMmg1czJvbjF3MDN3cGVoaiJ9.GtSFTpRtrSOpC89n1TN23w",
          {
            id: "mapbox/light-v9",
          }
        ).addTo(leaflet);
        // 标记
        // L.marker([37.78968, 112.560935]).addTo(leaflet).bindPopup("太原市小店区北美N1文创区").openPopup;

        // 自定义图标
        L.marker([37.78968, 112.560935], {
          icon: L.icon({
            iconUrl: "./static/map-pin.svg",
            iconSize: [50, 45],
          }),
        }).addTo(leaflet).bindPopup("太原市小店区北美N1文创区").openPopup;

        //增加一个圈，设置圆心、半径、样式
        // L.circle([37.78968, 112.560935], 80, {
        //   color: "red",
        //   fillColor: "#f03",
        //   fillOpacity: 0.5,
        // })
        //   .addTo(leaflet)
        //   .bindPopup("太原市小店区北美N1文创区");
      });

      // initialization of go to
      $(".js-go-to").each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
    });
  },
  methods:{
    submit(){
      console.log(this.$refs.form)
      this.$refs.form.validate((val)=>{
         if(val){
           console.log(val,this.form)
            let data = {hemail:this.form.email,hcompany:this.form.company,hmessage:this.form.message,hname:this.form.name,hproduct:this.form.product,}
             addhelp(data).then(res=>{
              console.log(res)
              if(res.status == 201){this.$notify.success({title:'提交成功'}); this.form={ name:null,product:null,email:null,message:null,company:null}}
            }).catch(err=>{this.$notify.console.error();({title:'提交失败'});})
         }else{
           return
         }
       })
    }
  }
};
</script>

<style scoped>
.mb-5 h1 {
  margin-bottom: 0.5rem;
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.mb-5 p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
  text-align: left;
}
.mb-1 {
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.4;
}
.font-size-1 {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788 !important;
  text-align: left;
}
.mb-0 {
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.4;
}
.small {
  line-height: 1.6;
  color: #677788;
}
 .el-form-item >>> .el-form-item__label{
   color: black;
   font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/contact.vue